import React, { useEffect, useState } from 'react';
import { Card, CardBody, Row, Col, Accordion, AccordionItem, AccordionHeader, AccordionBody, Table, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { MaterialReactTable } from 'material-react-table';
import { useDispatch, useSelector } from 'react-redux';
import { getView } from '../../slices/View/thunk';
import { fetchAllSessions } from '../../slices/sessions/getAllSessions/thunk';
import { LabelText } from '../Utils/Input';
import { UpdateSimulate } from './UpdateSimulate'; // Import the UpdateSimulate component
import moment from 'moment';
import { formatDateForDisplay, formatCellValue } from '../Utils/UtilityFunctions';
import { FormattedNumber } from './constants/FormatNumber';

// const FormattedNumber = ({ value, uom, showUom = true }) => {
//     if (!value || value === 0) return '-';

//     const numValue = parseFloat(value);

//     const formatWithCommas = (num) => {
//         return num.toLocaleString('en-US', {
//             minimumFractionDigits: 0,
//             maximumFractionDigits: 20
//         });
//     };

//     const truncateNumber = (num) => {
//         const str = num.toString();

//         const digits = str.replace(/[^0-9]/g, '');

//         if (digits.length <= 5) return str;

//         let digitCount = 0;
//         let truncateIndex = 0;

//         for (let i = 0; i < str.length; i++) {
//             if (/[0-9]/.test(str[i])) {
//                 digitCount++;
//                 if (digitCount === 5) {
//                     truncateIndex = i + 1;
//                     break;
//                 }
//             }
//         }

//         return str.substring(0, truncateIndex) + '...';
//     };

//     const truncatedValue = truncateNumber(numValue);
//     const fullFormattedValue = formatWithCommas(numValue);

//     return (
//         <span title={fullFormattedValue}>
//             {truncatedValue} {showUom && uom ? uom : ''}
//         </span>
//     );
// };

function LiveSessionListings({ customerId, setUpdateSession, sessionInfo, setSessionInfo, terminateSessions, setTerminateSessions }) {
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [buttonInitiateSession, setButtonInitiateSession] = useState(true);
    const dispatch = useDispatch();
    const [open, setOpen] = useState("1");

    const toggle = (id) => {
        setOpen(open === id ? "" : id);
    };

    const toggleModal = () => {
        setModalOpen(!modalOpen);
        if (modalOpen) {
            // Reset states when closing modal
            setUpdateSession(false);
            setTerminateSessions(false);
            setSessionInfo({});
        }
    };

    const handleUpdateSession = (sessionData, isTerminate = false) => {
        const sessionId = sessionData?.sessionId?.replace(/^TEST-SESSION-/, "");
        const sequenceNumber = (sessionData?.seqno?.at(-1) || 0) + 1;
        const subscriptionId = sessionData?.subscriptionId;
        const usageEventType = sessionData?.usageEventType;
        const uom = sessionData?.uom;
        const attribute = sessionData?.attributes;

        setSessionInfo({ sessionId, sequenceNumber, subscriptionId, usageEventType, uom, attribute });
        setUpdateSession(true);
        setTerminateSessions(isTerminate);
        setModalOpen(true);
    };

    const columns = [
        {
            accessorKey: 'sessionId',
            header: 'Session ID',
            Cell: ({ cell, row }) => {
                const sessionId = cell.getValue()?.replace(/^TEST-SESSION-/, "");
                return <span>{sessionId}</span>;
            },
        },
        {
            accessorKey: 'subscriptionId',
            header: 'Subscription ID',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'usageEventType',
            header: 'Event Type',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'startTime',
            header: 'Start Time',
            Cell: ({ cell }) => formatDateForDisplay(cell.getValue(), "hh:mm A"),

        },
        {
            accessorFn: (row) => {
                const startTime = row?.startTime;
                const expiryInSeconds = row?.expiryInSeconds;

                if (!startTime || !expiryInSeconds) return '-';

                const expiration = new Date(new Date(startTime).getTime() + expiryInSeconds * 1000);
                return expiration.toISOString(); // or format with moment
            },
            header: 'Expiration Time',
            Cell: ({ cell }) => {
                const isoTime = cell?.getValue();
                if (isoTime === '-') return '-';

                return formatDateForDisplay(isoTime, "hh:mm A");
            }
        },
        {
            accessorFn: (row) => {
                const mue = row?.ssi?.telcoInfo?.MUE;
                if (Array.isArray(mue) && mue?.length > 0) {
                    return `${mue[0]?.grantedServiceUnit ?? 0} ${mue[0]?.uom || row?.uom || ''}`;
                }
                return `${row?.grantedServiceUnit ?? 0} ${row?.uom || ''}`;
            },
            header: 'Reserved Units',
            Cell: ({ row }) => {
                const mue = row?.original?.ssi?.telcoInfo?.MUE;
                let value, uom;
                if (Array.isArray(mue) && mue?.length > 0) {
                    value = mue[0]?.grantedServiceUnit ?? 0;
                    uom = mue[0]?.uom || row?.original?.uom || '';
                } else {
                    value = row?.original?.grantedServiceUnit ?? 0;
                    uom = row?.original?.uom || '';
                }
                return <FormattedNumber value={value} uom={uom} maxLength={20} isTruncateMiddle={true} />;
            },
        },
        {
            accessorFn: (row) => {
                const mue = row?.ssi?.telcoInfo?.MUE;
                if (Array.isArray(mue) && mue?.length > 0) {
                    return `${mue[0]?.usedServiceUnit ?? 0} ${mue[0]?.uom || row?.uom || ''}`;
                }
                return `${row?.UsedServiceUnit ?? 0} ${row?.uom || ''}`;
            },
            header: 'Consumed Units',
            Cell: ({ row }) => {
                const mue = row?.original?.ssi?.telcoInfo?.MUE;
                let value, uom;
                if (Array.isArray(mue) && mue?.length > 0) {
                    value = mue[0]?.usedServiceUnit ?? 0;
                    uom = mue[0]?.uom || row?.original?.uom || '';
                } else {
                    value = row?.original?.UsedServiceUnit ?? 0;
                    uom = row?.original?.uom || '';
                }
                return <FormattedNumber value={value} uom={uom} maxLength={20} isTruncateMiddle={true} />;
            },
        },
    ];

    useEffect(() => {
        dispatch(getView(setLoading));
        dispatch(fetchAllSessions(customerId))
    }, [dispatch]);

    let sessionData = useSelector((state) => state.GetAllSessions.sessions)

    return (
        <React.Fragment>
            <div id='csms' className='mt-2'>
                <Row>
                    <Col lg={12}>
                        <div className="listingjs-table" id="customerList">
                            <div className="border rounded-1 px-3 my-2 bg-white mb-1 h-100">
                                <Row className="mb-3 table-responsive">
                                    {loading}
                                    {sessionData ?
                                        <>
                                            <MaterialReactTable
                                                icons={{
                                                    DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                }}
                                                positionToolbarAlertBanner="none"
                                                columns={columns}
                                                data={sessionData}
                                                enableTopToolbar={false}
                                                enableExpanding={true}
                                                defaultColumn={{
                                                    minSize: 1,
                                                    maxSize: 9001,
                                                    muiTableBodyCellProps: {
                                                        sx: {
                                                            fontFamily: 'Inter,sans-serif',
                                                        },
                                                    },
                                                    muiTableHeadCellProps: {
                                                        sx: {
                                                            fontFamily: 'Inter,sans-serif',
                                                        },
                                                    },
                                                }}
                                                enableColumnActions={true}
                                                enableDensityToggle={false}
                                                renderDetailPanel={({ row }) => {
                                                    const auditData = row?.original?.audit || [];
                                                    const initiateEvents = auditData.filter(event => event.eventType === "Started");
                                                    const updateEvents = auditData.filter(event => event.eventType === "Updated");
                                                    const isTestSession = row?.original?.sessionId?.startsWith('TEST-SESSION-') || false;
                                                    return (
                                                        <>
                                                            {row?.original?.balanceImpact && (
                                                                <>
                                                                    <div className="mt-3 mb-3 ms-2 fs-5">Charges</div>
                                                                    <Row>
                                                                        <Col lg={11}>
                                                                            <div className="border rounded-1 p-0 table-responsive mb-0 mt-2">
                                                                                <Table className="table table-borderless align-middle mb-0">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th className="p-3">Resource Name</th>
                                                                                            <th className="p-3">Offer Code</th>
                                                                                            <th className="p-3">Reserved Balance</th>
                                                                                            <th className="p-3">Consumed Balance</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {row?.original?.balanceImpact?.map((balance, idx, arr) => (
                                                                                            <tr key={idx} className={`${idx !== arr.length - 1 ? 'border-bottom' : ''}`}>
                                                                                                <td className="p-3">{balance?.resourceName}</td>
                                                                                                <td className="p-3">{balance?.offerCode}</td>
                                                                                                <td className="p-3">
                                                                                                    <FormattedNumber value={balance?.reservedServiceUnit} uom="" showUom={false} maxLength={20} isTruncateMiddle={true} />
                                                                                                </td>
                                                                                                <td className="p-3">
                                                                                                    <FormattedNumber value={balance?.ratedUnit} uom="" showUom={false} maxLength={20} isTruncateMiddle={true} />
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </Table>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                            )}
                                                            <div className="mt-3 mb-3 ms-2 fs-5">History</div>
                                                            <Row>
                                                                <Col lg={11}>
                                                                    <Accordion open={open} toggle={toggle} className="mt-2">
                                                                        <AccordionItem className="">
                                                                            <AccordionHeader targetId="1" className=''>Initiate</AccordionHeader>
                                                                            <AccordionBody accordionId="1">
                                                                                {initiateEvents.map((event, index) => (
                                                                                    <Row key={index} className="gy-4">
                                                                                        <Col xxl={3} md={4}>
                                                                                            <LabelText displayText="Start Time" classLabelName={'text-black fw-semibold'} />
                                                                                            <p className='text-black'>{moment((event?.timeStamp)).format("DD/MM/YYYY, hh:mm a")}</p>
                                                                                        </Col>
                                                                                        <Col xxl={3} md={4}>
                                                                                            <LabelText displayText="Requested Units" classLabelName={'text-black fw-semibold'} />
                                                                                            <p className='text-black'>
                                                                                                <FormattedNumber value={event?.requestedServiceUnits} uom={row?.original?.uom} maxLength={20} isTruncateMiddle={true} />
                                                                                            </p>
                                                                                        </Col>
                                                                                        <Col xxl={3} md={4}>
                                                                                            <LabelText displayText="Granted Units" classLabelName={'text-black fw-semibold'} />
                                                                                            <p className='text-black'>
                                                                                                <FormattedNumber value={event?.grantedServiceUnits} uom={row?.original?.uom} maxLength={20} isTruncateMiddle={true} />
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Row>
                                                                                ))}
                                                                            </AccordionBody>
                                                                        </AccordionItem>

                                                                        <AccordionItem className="">
                                                                            <AccordionHeader targetId="2" >
                                                                                <div className='d-flex justify-content-between w-100'>
                                                                                    <span>Update</span>
                                                                                    {isTestSession && (
                                                                                        <a

                                                                                            className="live-session-status-1 ms-n5"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                handleUpdateSession(row?.original, false);
                                                                                            }}
                                                                                        >
                                                                                            Update Session
                                                                                        </a>
                                                                                    )}
                                                                                </div>
                                                                            </AccordionHeader>
                                                                            <AccordionBody accordionId="2">
                                                                                {updateEvents && updateEvents.length > 0 ? (
                                                                                    updateEvents.map((event, index) => (
                                                                                        <Row
                                                                                            key={index}
                                                                                            className={`gy-4 mb-2 ${index === updateEvents.length - 1 ? '' : 'border-bottom'}`}
                                                                                        >
                                                                                            <Col xxl={2} md={4}>
                                                                                                <LabelText displayText="Sequence" classLabelName={'text-black fw-semibold'} />
                                                                                                <p className='text-black'>{event.seqno}</p>
                                                                                            </Col>
                                                                                            <Col xxl={2} md={4} className='me-5'>
                                                                                                <LabelText displayText="Event Time" classLabelName={'text-black fw-semibold'} />
                                                                                                <p className='text-black'>{moment((event?.timeStamp)).format("DD/MM/YYYY, hh:mm a")}</p>
                                                                                            </Col>
                                                                                            <Col xxl={2} md={4} className='me-5'>
                                                                                                <LabelText displayText="Requested Units" classLabelName={'text-black fw-semibold'} />
                                                                                                <p className='text-black'>
                                                                                                    <FormattedNumber value={event?.requestedServiceUnits || '0'} uom={row?.original?.uom} maxLength={20} isTruncateMiddle={true} />
                                                                                                </p>
                                                                                            </Col>
                                                                                            <Col xxl={2} md={4} className='me-5'>
                                                                                                <LabelText displayText="Granted Units" classLabelName={'text-black fw-semibold'} />
                                                                                                <p className='text-black'>
                                                                                                    <FormattedNumber value={event?.grantedServiceUnits || '0'} uom={row?.original?.uom} maxLength={20} isTruncateMiddle={true} />
                                                                                                </p>
                                                                                            </Col>
                                                                                            <Col xxl={2} md={4} className='me-5'>
                                                                                                <LabelText displayText="Consumed Units" classLabelName={'text-black fw-semibold'} />
                                                                                                <p className='text-black'>
                                                                                                    <FormattedNumber value={event?.usedServiceUnits || '0'} uom={row?.original?.uom} maxLength={20} isTruncateMiddle={true} />
                                                                                                </p>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    ))
                                                                                ) : (
                                                                                    <p className="text-center text-muted">No data available</p>
                                                                                )}
                                                                            </AccordionBody>
                                                                        </AccordionItem>
                                                                        <AccordionItem className="">
                                                                            <div className=' p-3 d-flex justify-content-between align-items-center '>
                                                                                <span className='fw-semibold'>Terminate</span>
                                                                                {isTestSession && (
                                                                                    <div className='ms-n5 '>
                                                                                        <a
                                                                                            className="live-session-status-1 fw-semibold ms-n5"
                                                                                            onClick={() => {
                                                                                                handleUpdateSession(row?.original, true);
                                                                                            }}
                                                                                        >
                                                                                            Terminate Session
                                                                                        </a>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </AccordionItem>
                                                                    </Accordion>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    );
                                                }}
                                            />
                                        </>
                                        : null
                                    }
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Modal for Update/Terminate Session */}
            <Modal
                isOpen={modalOpen}
                toggle={toggleModal}
                size="md"
                backdrop="static"
                keyboard={false}
                className="modal-dialog-centered"
            >
                <button
                    type="button"
                    className="close-button-currency mt-n1"
                    onClick={toggleModal}
                >
                    &times;
                </button>
                <h5 className="text-center w-100 mt-0 fw-semibold py-3 rv-breadcrumb-border">
                    {terminateSessions ? 'Terminate Session' : 'Update Session'}
                </h5>
                <ModalBody>
                    <UpdateSimulate
                        updateSession={true}
                        setUpdateSession={setUpdateSession}
                        sessionInfo={sessionInfo}
                        terminateSessions={terminateSessions}
                        setTerminateSessions={setTerminateSessions}
                        setButtonInitiateSession={setButtonInitiateSession}
                        onClose={toggleModal} // Pass close function to UpdateSimulate
                    />
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default LiveSessionListings;